/* IUTIENDA v37 WOW JS — Desarrollado por CUAN.STUDIO (cuan.studio) */
(function(){
  'use strict';
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* Marquee en la barra de anuncio */
  var ann = document.querySelector('.announcement-bar__inner');
  if (ann && !ann.querySelector('.annq-track')) {
    var html = ann.innerHTML.trim();
    ann.innerHTML = '<div class="annq-track">' + html + html + html + '</div>';
  }

  /* Reveal al hacer scroll (sin tocar plantillas) */
  if (!reduce && 'IntersectionObserver' in window) {
    var targets = document.querySelectorAll('.product-card, .category-card, .footer-feature, .section-header, .section-title');
    var io = new IntersectionObserver(function(entries){
      entries.forEach(function(e){
        if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); }
      });
    }, { threshold: 0.08 });
    targets.forEach(function(el, i){
      el.classList.add('wow-reveal');
      el.style.transitionDelay = ((i % 4) * 70) + 'ms';
      io.observe(el);
    });
  }

  /* Feedback al agregar al carrito */
  document.addEventListener('click', function(e){
    var btn = e.target.closest('.add-to-cart-btn');
    if (!btn || btn.classList.contains('added')) return;
    var orig = btn.innerHTML;
    setTimeout(function(){
      btn.classList.add('added');
      btn.innerHTML = '<i class="fas fa-check"></i> ¡Agregado!';
      setTimeout(function(){ btn.classList.remove('added'); btn.innerHTML = orig; }, 1600);
    }, 350);
  });

  /* Barra pegajosa de compra en móvil (página de producto) */
  if (document.body.classList.contains('template-product')) {
    var form = document.getElementById('product-form-main');
    var mainBtn = form ? form.querySelector('.add-to-cart-btn') : null;
    var titleEl = document.querySelector('.product-info__title');
    var priceEl = document.querySelector('.product-info__price .price');
    if (form && mainBtn && titleEl) {
      var bar = document.createElement('div');
      bar.className = 'sticky-atc';
      bar.innerHTML = '<div class="sticky-atc__info"><span class="sticky-atc__t"></span><span class="sticky-atc__p"></span></div>' +
        '<button type="button" class="btn btn--primary sticky-atc__btn"><i class="fas fa-shopping-cart"></i> Agregar</button>';
      document.body.appendChild(bar);
      bar.querySelector('.sticky-atc__t').textContent = titleEl.textContent.trim();
      bar.querySelector('.sticky-atc__p').textContent = priceEl ? priceEl.textContent.trim() : '';
      bar.querySelector('.sticky-atc__btn').addEventListener('click', function(){ mainBtn.click(); });
      if ('IntersectionObserver' in window) {
        var io2 = new IntersectionObserver(function(entries){
          bar.classList.toggle('on', !entries[0].isIntersecting);
        }, { rootMargin: '-80px 0px 0px 0px' });
        io2.observe(mainBtn);
      } else {
        bar.classList.add('on');
      }
    }
  }
})();
